/**
 * A chance as a percent, exact to the roll's resolution: one part in 1,000,000 is 0.0001%, so four
 * decimals and no trailing zeros (12.5%, 0.0012%), as `getItemChance` publishes it. Never rounded
 * further: published odds are a compliance surface.
 */
export function formatChance(percent: number): string {
  return `${Number(percent.toFixed(4))}%`;
}
